export const OASYS_CONST = {
    WEEKLY_EMPL_TYPE_TS: 'W',
    MONTHLY_EMPL_TYPE_TS: 'M'
}